var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FC686F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.75 21H38.8175L32.1175 28.6775L40 39.125H33.8287L28.995 32.7875L23.4637 39.125H20.395L27.5612 30.9125L20 21H26.3288L30.6975 26.7912L35.75 21ZM34.675 37.285H36.375L25.4037 22.7437H23.5812L34.675 37.285Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareXIcon);
export default __webpack_public_path__ + "static/media/share-x-icon.092b48c71e625cc164ba99dc1358a62a.svg";
export { ForwardRef as ReactComponent };